const demo = {
  SITE_URL: 'https://app.veritaris.me',
  API_URL: 'https://app.veritaris.me/api/v1/',
  WEBSOCKET_URL: 'wss://app.veritaris.me/ws',
};

export { demo as default };
